(() => {
  const manualCountryKey = 'pw-localization-manual-country';
  const manualCountryCookie = 'pw_localization_manual_country';
  const manualChoiceParam = 'pw_country_selected';

  function readCookie(name) {
    if (!document.cookie) return '';
    const prefix = `${name}=`;
    return document.cookie.split('; ').find((item) => item.startsWith(prefix))?.slice(prefix.length) || '';
  }

  function hasManualCountryChoice() {
    try {
      return Boolean(window.localStorage.getItem(manualCountryKey) || readCookie(manualCountryCookie));
    } catch (_) {
      return Boolean(readCookie(manualCountryCookie));
    }
  }

  function rememberManualCountryChoice(countryCode) {
    if (!countryCode) return;
    try {
      window.localStorage.setItem(manualCountryKey, countryCode);
    } catch (_) {}
    document.cookie = `${manualCountryCookie}=${encodeURIComponent(countryCode)}; path=/; max-age=31536000; SameSite=Lax`;
  }

  function selectableCountries() {
    return [...new Set([...document.querySelectorAll('button[name="country_code"]')].map((button) => button.value))];
  }

  function restoreManualChoiceFromUrl(allowedCountries) {
    const url = new URL(location.href);
    const countryCode = url.searchParams.get(manualChoiceParam);
    if (!countryCode) return;
    if (allowedCountries.includes(countryCode)) rememberManualCountryChoice(countryCode);
    url.searchParams.delete(manualChoiceParam);
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }

  function resolveTargetCountry(context, availableCountries) {
    const target = context?.detected_values?.country?.handle;
    return target && availableCountries.includes(target) ? target : '';
  }

  window.PWLocalizationContext = { resolveTargetCountry };

  async function detectVisitorCountry() {
    const endpoint = new URL(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json`, location.origin);
    endpoint.searchParams.set('country[enabled]', 'true');
    try {
      const response = await fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      return response.ok ? await response.json() : null;
    } catch (_) {
      return null;
    }
  }

  function submitCountry(targetCountry) {
    const form = document.createElement('form');
    form.action = `${window.Shopify?.routes?.root || '/'}localization`;
    form.method = 'post';
    form.hidden = true;
    form.dataset.pwAutoLocalization = 'true';
    for (const [name, value] of Object.entries({
      _method: 'put',
      country_code: targetCountry,
      return_to: location.pathname + location.search + location.hash
    })) {
      const input = document.createElement('input');
      input.name = name;
      input.value = value;
      form.append(input);
    }
    document.body.append(form);
    form.submit();
  }

  function registerManualChoiceListener() {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.pwAutoLocalization === 'true') return;
      const submitter = event.submitter;
      const countryCode = submitter?.getAttribute('name') === 'country_code' ? submitter.value : new FormData(form).get('country_code');
      if (!countryCode) return;
      rememberManualCountryChoice(countryCode);
      const returnUrl = new URL(location.href);
      returnUrl.searchParams.set(manualChoiceParam, countryCode);
      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.name = 'return_to';
        form.append(returnInput);
      }
      returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
    }, true);
  }

  async function restoreCountryContext(script) {
    const selectable = selectableCountries();
    restoreManualChoiceFromUrl(selectable);
    if (hasManualCountryChoice()) return;

    const currentCountry = script.dataset.currentCountry;
    const availableCountries = script.dataset.availableCountries.split(',').filter(Boolean);
    if (!currentCountry) return;

    const targetCountry = resolveTargetCountry(await detectVisitorCountry(), availableCountries);
    if (!targetCountry || !selectable.includes(targetCountry)) return;
    if (targetCountry !== currentCountry) submitCountry(targetCountry);
  }

  if (!document.addEventListener) return;
  document.addEventListener('DOMContentLoaded', () => {
    registerManualChoiceListener();
    const script = document.currentScript || document.querySelector('[data-pw-localization-context]');
    if (script) restoreCountryContext(script);
  }, { once: true });
})();
